import { en } from './en';
import { he } from './he';

export const bannerTranslations = {
  en,
  he
};

export type BannerTranslationKey = keyof typeof bannerTranslations;
export type BannerTranslation = typeof bannerTranslations.he; 